import { useEffect, useState } from 'react';

import {
    Chip,
    ListSubheader,
    MenuItem,
    Grid,
    Checkbox,
    Button,
    Box,
    Typography,
    ListItem
} from '@mui/material';

import { grey, blue, yellow } from '@mui/material/colors';

import { CommonIcons, icons } from '../../components/common/CommonIcons'

import { useInventories, inventoriesTypes } from '../api/useInventories';
import { useSystemPrompt } from '../useSystemPrompt';
import { useTranslations } from "../useTranslations";

const _skipBatchId = 'skip';
const _skipBatchObject = {
    batchId: _skipBatchId,
    label: `Skip Stock Post`,
}

export function useStateInventoryBatches(
    {
        // multiple = false
        locationId = ''
    }
) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { promptMessage } = useSystemPrompt()

    const [isLoading, setIsLoading] = useState(false)

    const { list: listInventories, filterOperatorTypes } = useInventories({ inventoriesType: inventoriesTypes.inventory })

    const [dataInventoryBatches, setDataInventoryBatches] = useState([])
    const [skipIndexNoArray, setSkipIndexNoArray] = useState([])

    const [checkBatchIds, setCheckBatchIds] = useState([])
    const [checkIndex, setCheckIndex] = useState(false)

    useEffect(() => {

        let d = [];

        (dataInventoryBatches).forEach((e2, ind) => {

            let batches = [];

            e2?.batches.forEach((i2, index2) => {

                let a = i2;

                if (checkBatchIds.includes(i2.batchId)) {
                    a.selectedIndexNo = checkIndex
                } else {
                    a.selectedIndexNo = false
                }

                batches.push(a)
            })

            d.push({
                itemId: e2.itemId,
                batches
            })
        })

        setDataInventoryBatches(d)


    }, [checkBatchIds])

    const getInventoryBatchesByItemId = ({ itemId, selectedIndexNo }) => {
        const data = dataInventoryBatches.filter(i => i.itemId === itemId)

        let batches = [];

        batches.push(_skipBatchObject)

        if (data.length) {
            batches = batches.concat(
                data[0].batches.filter(i => i.selectedIndexNo === false || i.selectedIndexNo === selectedIndexNo)
            )
        }

        return batches
    }

    // query more Inventory Batches data by Item Id
    const appendInventoryBatch = async ({ itemId, selectedIndexNo, /* callback */ }) => {

        // to remove the selection (if any)
        // if (multiple === false) 
        removeAllSelectedIndexNo({ selectedIndexNo })

        // check the itemId is in the data saved
        const checkExist = dataInventoryBatches.filter(i => i.itemId === itemId)

        // console.log('checkExist', checkExist)

        if (checkExist.length <= 0) { // only if not exist will query more
            await fetchInventoryBatch({ itemId })
        }

        // if (callback) {
        //     callback({
        //         itemId,
        //         selectedIndexNo
        //     })
        // }

    }

    // multiple - query more Inventory Batches data by Item Id
    const appendMutipleInventoryBatch = async (array) => {

        await array.forEach(async (i, index) => {
            const { itemId, selectedIndexNo } = i

            // to remove the selection (if any)
            removeAllSelectedIndexNo({ selectedIndexNo })

            // check the itemId is in the data saved
            const checkExist = dataInventoryBatches.filter(i => i.itemId === itemId)

            if (checkExist.length <= 0) { // only if not exist will query more
                await fetchInventoryBatch({ itemId })
            }

        })

    }

    const getBatchObject = ({
        itemId,
        batchNo,
        expiryDate,
        rackId,
        rackName,
        slotId,
        slotName,
        maxQty
    }) => {

        let batchId = `${itemId}`

        batchId += batchNo ? `_${batchNo}` : `_*`
        batchId += expiryDate ? `_${expiryDate}` : `_*`
        batchId += `_${rackId}_${slotId}`

        let label = `${batchNo}`;
        label += expiryDate ? ` (Expiry : ${expiryDate})` : ``
        label += rackName ? ` From ${rackName}/${slotName}` : ``
        label += maxQty ? ` (Qty: ${maxQty})` : ``

        return {
            batchId,
            label
        }

    }

    const removeAllSelectedIndexNo = ({ selectedIndexNo }) => {

        const newState = dataInventoryBatches;

        newState.forEach((e1, index1) => {

            let newBatches = e1.batches.map(i => {

                if (i.selectedIndexNo === selectedIndexNo) { // if match the batch Id
                    return { ...i, selectedIndexNo: false }
                }

                return i // not irrelevant batch

            })

            newState[index1].batches = newBatches
        })

        setDataInventoryBatches(prev => newState)

    }

    const resetDataInventoryBatches = () => {
        setDataInventoryBatches([])
    }

    const deselectByBatchIds = ({ batchIds = [] }) => {

        // console.log('batchIds ---> ', batchIds)

        const newState = dataInventoryBatches;

        newState.forEach((e1, index1) => {

            let newBatches = e1.batches.map(i => {

                if (batchIds.includes(i.batchId) === true) { // if match the batch Id
                    // console.log('reset', i.batchId)
                    return { ...i, selectedIndexNo: false }
                }

                return i // not irrelevant batch

            })

            newState[index1].batches = newBatches
        })

        // console.log('new State', newState)

        setDataInventoryBatches(prev => newState)

    }

    const selectInventoryBatch = ({ itemId, batchId, selectedIndexNo }) => {

        // console.log('newState', dataInventoryBatches)

        // to remove the selection (if any)
        // if (multiple === false) {
        // }
        removeAllSelectedIndexNo({ selectedIndexNo })

        // check the select is skip option
        if (batchId === _skipBatchId) {

            // check the skip is already in array
            if (skipIndexNoArray.indexOf(selectedIndexNo) > -1) {
                // remove the saved index (if any)
                setSkipIndexNoArray(
                    prev => skipIndexNoArray.filter(i => i !== selectedIndexNo)
                )
            } else {
                setSkipIndexNoArray(
                    prev => skipIndexNoArray.concat(selectedIndexNo)
                )
            }

            return false
        }

        const newState = dataInventoryBatches;

        // console.log('newState >> ', newState)

        let returnBatch = {};

        // to update the selection
        newState.forEach((e1, index1) => {
            if (e1.itemId === itemId) {

                let newBatches = e1.batches.map(i => {

                    if (i.batchId === batchId) { // if match the batch Id
                        returnBatch = { ...i, selectedIndexNo }
                        return returnBatch
                    }

                    return i // not irrelevant batch


                })

                newState[index1].batches = newBatches
            }
        })

        setDataInventoryBatches(prev => newState)

        // need to remove the skip index once the success index updated
        setSkipIndexNoArray(
            prev => skipIndexNoArray.filter(i => i !== selectedIndexNo)
        )

        return returnBatch;

    }

    const getSelectedInventoryBatch = ({ selectedIndexNo }) => {

        // check the selectedIndexNo is in skipArray
        if (skipIndexNoArray.indexOf(selectedIndexNo) > -1) {
            return _skipBatchObject
        }

        let selected = {};

        dataInventoryBatches.forEach((e1, index1) => {

            let found = e1.batches.filter(i => {

                if (i.selectedIndexNo === selectedIndexNo) { // if found selected index no
                    return true
                }

                return false

            })

            if (found.length) {
                selected = found[0];
            }

        })

        return selected

    }

    const fetchInventoryBatch = async ({ itemId }) => {

        setIsLoading(true)

        try {

            let filterValues = [
                {
                    name: "id",
                    operator: filterOperatorTypes.eq,
                    value: itemId
                },
            ]

            if (locationId) {
                filterValues.push({
                    name: "location_id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify([locationId])
                })
            }

            let props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "rack_name",
                    dir: 0,
                },
                filterValue: filterValues,
                dataTypes: ["group_slot_batch"]
            }

            let { data } = await listInventories(props);

            let initialBatches = [];

            data?.inventories.forEach((e1) => {

                // let batchId = Date.now().toString().concat("_", Math.floor(Math.random() * 100))

                const {
                    custom_batch_no: customBatchNo,
                    expiry_date: expiryDate,
                    rack_id: rackId,
                    rack_name: rackName,
                    rack_type: rackType,
                    slot_id: slotId,
                    slot_name: slotName,
                    total_remain_qty: totalRemainQty
                } = e1

                // generate the unique batch id
                let { batchId, label } = getBatchObject({
                    itemId,
                    batchNo: customBatchNo,
                    expiryDate,
                    rackId,
                    rackName,
                    slotId,
                    slotName,
                    maxQty: totalRemainQty
                })

                let labels = {
                    customBatchNo,
                    expiryDate,
                    rackName,
                    slotName,
                    totalRemainQty
                }

                initialBatches.push({
                    itemId,
                    batchId,
                    label,
                    labels,
                    customBatchNo,
                    expiryDate,
                    rackId,
                    rackName,
                    rackType,
                    slotId,
                    slotName,
                    totalRemainQty,
                    selectedIndexNo: false,
                    isSkipBatch: false,
                })
            })

            setDataInventoryBatches(
                prev =>
                    [
                        ...prev,
                        {
                            itemId,
                            batches: initialBatches
                        }
                    ]
            )

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setIsLoading(false)
    }

    // get the <select> renderValue component
    const RenderValueComponent = ({ item }) => {

        return (
            <>
                <Chip
                    label={item?.customBatchNo ? item.customBatchNo : '-'}
                    size="small"
                />
                <Chip
                    label={item?.expiryDate ? item.expiryDate : '-'}
                    size="small"
                />
            </>
        )
    }

    const RenderSubHeaderComponent = ({ /* enableMultipleSelection = false, */ index, itemId }) => {

        // if (enableMultipleSelection) {
        //     return (
        //         <ListSubheader color={"primary"} disableGutters>
        //             {JSON.stringify(checkBatchIds)}
        //             <Box sx={{ backgroundColor: (theme) => theme.palette.primary.main, px: 1.5, py: 0, m: 0 }} >
        //                 <Grid container sx={{ color: '#fff' }} spacing={0} columnSpacing={0} rowGap={0} rowSpacing={0}>
        //                     {/* <Grid item xs={1} sm={1} md={1} textAlign={"left"}>
        //                         <Checkbox />
        //                     </Grid> */}
        //                     <Grid item xs={5} sm={5} md={5} display={"flex"} justifyContent={"flex-start"}>
        //                         Batch No.
        //                     </Grid>
        //                     <Grid item xs={3} sm={3} md={3} display={"flex"} justifyContent={"flex-start"}>
        //                         Expiry Date
        //                     </Grid>
        //                     <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"}>
        //                         Storage
        //                     </Grid>
        //                     <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"}>
        //                         Qty
        //                     </Grid>
        //                 </Grid>
        //             </Box>
        //             <Box sx={{ backgroundColor: '#000', py: 0, m: 0 }} >
        //                 <Button
        //                     fullWidth
        //                     variant="text"
        //                     sx={{ my: 0, color: '#fff' }}
        //                     size='small'
        //                     onClick={() => {

        //                         const a = document.getElementsByClassName("myCheckbox")

        //                         let batchIds = [];

        //                         for (let i = 0; i < a.length; i += 1) {

        //                             let input = a.item(i).getElementsByTagName('input')

        //                             if (a.item(i).classList.contains("Mui-checked")) {
        //                                 batchIds.push(input[0].value)
        //                             }

        //                         }

        //                         setCheckBatchIds(batchIds)
        //                         setCheckIndex(index)

        //                     }}
        //                 >Confirm</Button>
        //             </Box>
        //         </ListSubheader>
        //     )
        // }

        return (
            <ListSubheader color={"primary"} disableGutters>
                <Box sx={{ backgroundColor: (theme) => theme.palette.primary.main, px: 1.5, py: 0, m: 0 }} >
                    <Grid container sx={{ color: '#fff' }} spacing={0} columnSpacing={0} rowGap={0} rowSpacing={0}>
                        <Grid item xs={5} sm={5} md={5} display={"flex"} justifyContent={"flex-start"}>
                            {t('batchNo')}
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} display={"flex"} justifyContent={"flex-start"}>
                            {t('expiryDate')}
                        </Grid>
                        <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"}>
                            {t('storage')}
                        </Grid>
                        <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"}>
                            {t('qty')}
                        </Grid>
                    </Grid>
                </Box>
            </ListSubheader>
        )
    }

    const RenderDisplayText = ({ text }) => {
        return (
            <Typography
                sx={{
                    fontSize: 13
                }}
            >
                {text}
            </Typography>
        )
    }

    const RenderMenuItemComponent = ({ index, item, selected = false, style = {},/* enableMultipleSelection = false */ }) => {

        // check the invalid data
        if (!item?.labels?.totalRemainQty) return <Box key={index}><></></Box>

        // if (enableMultipleSelection) {

        //     let value = item?.batchId;

        //     return (
        //         // <ListItem
        //         //     key={index}
        //         //     disableGutters
        //         //     disablePadding
        //         //     divider
        //         //     sx={{
        //         //         width: '100%',
        //         //     }}
        //         // >
        //         <MenuItem
        //             key={index}
        //             value={item.batchId}
        //             sx={{
        //                 textTransform: 'capitalize',
        //                 px: 1.5,
        //                 fontSize: 14,
        //                 width: '100%',
        //                 ...style
        //             }}
        //             disableGutters
        //             divider
        //         >
        //             <Grid container style={style}>
        //                 {/* <Grid item xs={1} sm={1} md={2} display={"flex"} alignItems={"center"} justifyContent={"center"}>
        //                     {
        //                         JSON.stringify(checkBatchIds.includes(value))
        //                     }
        //                     <Checkbox
        //                         size='small'
        //                     />
        //                 </Grid> */}
        //                 <Grid item xs={5} sm={5} md={5} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
        //                     <RenderDisplayText text={item?.labels?.customBatchNo} />
        //                 </Grid>
        //                 <Grid item xs={3} sm={3} md={3} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
        //                     <RenderDisplayText text={item?.labels?.expiryDate} />
        //                 </Grid>
        //                 <Grid item xs={2} sm={2} md={2} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
        //                     <RenderDisplayText text={`${item?.labels?.rackName}/${item?.labels?.slotName}`} />
        //                 </Grid>
        //                 <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"} alignItems={"flex-end"} sx={{ pr: 1 }}>
        //                     <RenderDisplayText text={item?.labels?.totalRemainQty} />
        //                 </Grid>
        //             </Grid >
        //             {/* </ListItem> */}
        //         </MenuItem>
        //     )
        // }

        return (
            <MenuItem
                key={index}
                value={item.batchId}
                sx={{
                    textTransform: 'capitalize',
                    px: 1.5,
                    fontSize: 14,
                    width: '100%',
                    // backgroundColor: selected ? yellow[500] : grey[50],
                    ...style
                }}
                disableGutters
                divider
                selected={selected}
            >
                <Grid container spacing={1}>
                    <Grid item xs={5} sm={5} md={5} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
                        {
                            selected &&
                            <CommonIcons name={icons.tick} sx={{ width: 15, height: 15, mr: 1 }} />
                        }
                        {item?.labels?.customBatchNo}
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
                        {item?.labels?.expiryDate}
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                        {item?.labels?.rackName}/{item?.labels?.slotName}
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                        {parseFloat(item?.labels?.totalRemainQty)}
                    </Grid>
                </Grid>


                {/* {i.label} */}
            </MenuItem>
        )
    }

    return {
        isLoading,
        skipBatchId: _skipBatchId,
        skipIndexNoArray,
        dataInventoryBatches,
        resetDataInventoryBatches,
        getBatchObject,
        selectInventoryBatch,
        getSelectedInventoryBatch,
        getInventoryBatchesByItemId,
        appendInventoryBatch,
        appendMutipleInventoryBatch,
        removeAllSelectedIndexNo,
        deselectByBatchIds,

        /** Component  */
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
        RenderDisplayText
        // filterOperatorTypes,
        // list,
        // get, 
        // create,
        // update, 
        // remove 
    }

}